import { z } from 'zod';
const uuid = z.string().uuid();
export const assistantConversationStatusSchema = z.enum(['active', 'archived']);
export const assistantConversationRoleSchema = z.enum(['user', 'assistant', 'system']);
export const assistantConversationSchema = z.strictObject({
    id: uuid,
    tenantId: uuid,
    ownerMembershipId: uuid,
    title: z.string().trim().min(1).max(160).nullable(),
    status: assistantConversationStatusSchema,
    revision: z.number().int().positive(),
    createdAt: z.string().datetime({ offset: true }),
    archivedAt: z.string().datetime({ offset: true }).nullable(),
    archivedByMembershipId: uuid.nullable(),
});
export const assistantConversationMessageSchema = z.strictObject({
    id: uuid,
    tenantId: uuid,
    conversationId: uuid,
    sequence: z.number().int().positive(),
    role: assistantConversationRoleSchema,
    content: z.record(z.string().min(1).max(120), z.unknown()),
    contentHash: z.string().regex(/^[a-f0-9]{64}$/),
    createdByMembershipId: uuid.nullable(),
    createdAt: z.string().datetime({ offset: true }),
});
export const assistantConversationCreateSchema = z.strictObject({
    commandId: uuid,
    title: z.string().trim().min(1).max(160).nullable().default(null),
});
export const assistantConversationMessageAppendSchema = z.strictObject({
    commandId: uuid,
    conversationId: uuid,
    role: z.literal('user'),
    content: z.record(z.string().min(1).max(120), z.unknown()),
});
export const assistantConversationArchiveSchema = z.strictObject({
    commandId: uuid,
    conversationId: uuid,
    expectedRevision: z.number().int().positive(),
    reason: z.string().trim().min(10).max(500),
});
//# sourceMappingURL=assistant-conversation.contract.js.map